export const PAYMENT_PROVIDER_CODES = [
  'linkmepay',
  'btcpay',
  'zeroxprocessing',
  'meld',
  'ggusonepay',
] as const;

export const GAME_PROVIDER_CODES = [
  'bluedragon',
  'gamevault',
  'cashier',
  'jack2win',
  'vegas7games',
  'pmterminal',
  'fkterminal',
  'megaspin',
  'noble777',
  'mwterminal',
  'osterminal',
  'cashfrenzy',
  'glamorspin',
  'galaxyworld',
  'mrallinone',
  'gameroom',
  'vegasroll',
  'mafia77777',
  'riverpay',
  'lasvegassweeps',
] as const;
